import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { 
    ReservationCreate,
    CustomerReservationList,
    ReservationDetail,
    ReservationSearchCriteria,
    ReservationUpdateDTO,
    OfferActionResponse
} from '../../_models/reservation.model';
import { ApiResponse } from '../../_models/api-response.model';

@Injectable({
    providedIn: 'root'
})
export class ClientReservationService {
    private userApiUrl = `${environment.apiUrl}/reservations`;

    constructor(private http: HttpClient) { }

    createReservation(reservationCreate: ReservationCreate): Observable<ApiResponse<ReservationDetail>> {
        return this.http.post<ApiResponse<ReservationDetail>>(this.userApiUrl, reservationCreate);
    }

    getMyReservations(
        criteria: ReservationSearchCriteria = {},
        page: number = 0,
        size: number = 10,
        sort: string = 'createdAt',
        direction: string = 'DESC'
    ): Observable<ApiResponse<CustomerReservationList[]>> {
        let params = new HttpParams();
        
        if (criteria.search) {
            params = params.set('search', criteria.search);
        }
        if (criteria.clientId) {
            params = params.set('clientId', criteria.clientId.toString());
        }
        if (criteria.startDateFrom) {
            params = params.set('startDateFrom', criteria.startDateFrom);
        }
        if (criteria.startDateTo) {
            params = params.set('startDateTo', criteria.startDateTo);
        }
        if (criteria.clientStatus) {
            params = params.set('clientStatus', criteria.clientStatus);
        }
        if (criteria.adminStatus) {
            params = params.set('adminStatus', criteria.adminStatus);
        }

        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        params = params.set('sort', sort);
        params = params.set('direction', direction);

        return this.http.get<ApiResponse<CustomerReservationList[]>>(`${this.userApiUrl}`, { params });
    }

    getReservationDetails(reservationId: number): Observable<ApiResponse<ReservationDetail>> {
        return this.http.get<ApiResponse<ReservationDetail>>(`${this.userApiUrl}/${reservationId}`);
    }


    acceptOffer(reservationId: number, offerId: number): Observable<ApiResponse<ReservationDetail>> {
        return this.http.post<ApiResponse<ReservationDetail>>(
            `${this.userApiUrl}/${reservationId}/offers/${offerId}/accept`, 
            {}
        );
    }

    rejectOffer(reservationId: number, offerId: number): Observable<ApiResponse<ReservationDetail>> {
        return this.http.post<ApiResponse<ReservationDetail>>(
            `${this.userApiUrl}/${reservationId}/offers/${offerId}/reject`, 
            {}
        );
    }

    requestNewOffer(reservationId: number): Observable<ApiResponse<ReservationDetail>> {
        return this.http.post<ApiResponse<ReservationDetail>>(
            `${this.userApiUrl}/${reservationId}/request-new-offer`, 
            {}
        );
    }

    updateReservation(reservationId: number, updateData: ReservationUpdateDTO): Observable<ApiResponse<ReservationDetail>> {
        return this.http.put<ApiResponse<ReservationDetail>>(
            `${this.userApiUrl}/${reservationId}`, 
            updateData
        );
    }

    cancelReservation(reservationId: number): Observable<ApiResponse<void>> {
        return this.http.post<ApiResponse<void>>(
            `${this.userApiUrl}/${reservationId}/cancel`, 
            {}
        );
    }

    deleteReservation(reservationId: number): Observable<ApiResponse<void>> {
        return this.http.delete<ApiResponse<void>>(
            `${this.userApiUrl}/${reservationId}`
        );
    }
}